import PrebuiltAccaClassicImpl from './prebuilt-acca-classic.js';
import MojitoCore from 'mojito/core';
import PropTypes from 'prop-types';
import EventCardsTypes from 'modules/event-cards/types.js';

const UIView = MojitoCore.Presentation.UIView;

/**
 * PrebuiltAccaClassic view that renders prebuilt acca card with the classic layout.
 *
 * @class PrebuiltAccaClassic
 * @memberof Mojito.Modules
 */

/**
 * PrebuiltAccaClassic prop types.
 *
 * @property {object} event - Event data.
 * @property {object} market - Market data.
 * @property {string|undefined} [promotionText] - Promotion text to be displayed on the card.
 * @property {Function} [onEventClick] - Callback to get state of child element loading.
 * @property {string} [imgUrl] - Optional card background image.
 * @property {Mojito.Modules.EventCards.types.COLOR_MODES} [colorMode] - Card presentation mode.
 * @property {object} icons - Icons map.
 *
 * @memberof Mojito.Modules.PrebuiltAccaClassic
 */
const propTypes = {
    event: PropTypes.object.isRequired,
    market: PropTypes.object.isRequired,
    promotionText: PropTypes.string,
    onEventClick: PropTypes.func,
    imgUrl: PropTypes.string,
    colorMode: PropTypes.oneOf(Object.values(EventCardsTypes.COLOR_MODES)),
    icons: PropTypes.object,
};

export default UIView('PrebuiltAccaClassic', PrebuiltAccaClassicImpl, propTypes);
